<img
  [attr.aria-label]="alt"
  [src]="src"
  [alt]="alt"
  [height]="height"
  [width]="width"
  [class]="imgClassName"
  [attr.loading]="loading"
/>
